import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Trophy, Award, Settings, Info } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const reqLabel = (req) => {
  if (!req || req.length === 0) return null;
  if (req.includes('linha') && !req.includes('defesa')) return 'Só Linha';
  if (req.includes('guarda_redes') && req.length === 1) return 'Só Guarda-Redes';
  if (req.includes('defesa') && req.includes('guarda_redes')) return 'Defesa + GR';
  return req.join(' + ');
};

const PontuacaoPage = () => {
  const [config, setConfig] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/rating-config`)
      .then(r => setConfig(r.data?.config || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const positives = config.filter(c => c.weight > 0);
  const negatives = config.filter(c => c.weight < 0);
  const inactive = config.filter(c => c.weight === 0);

  const Row = ({ item }) => (
    <li className="flex items-center justify-between py-2 border-b border-zinc-200 last:border-b-0">
      <div className="flex items-center gap-2 flex-wrap">
        <span className="font-bold">{item.label}</span>
        {item.position_required && reqLabel(item.position_required) && (
          <span className="text-[10px] bg-blue-100 text-blue-800 px-2 py-0.5 rounded-full font-bold">
            {reqLabel(item.position_required)}
          </span>
        )}
        {item.custom && (
          <span className="text-[10px] bg-purple-100 text-purple-800 px-2 py-0.5 rounded-full font-bold">
            PERSONALIZADO
          </span>
        )}
      </div>
      <span className={`font-black text-lg ${item.weight > 0 ? 'text-green-600' : item.weight < 0 ? 'text-red-600' : 'text-zinc-400'}`}>
        {item.weight > 0 ? '+' : ''}{item.weight}
      </span>
    </li>
  );

  return (
    <div className="min-h-screen bg-zinc-50">
      <header className="bg-zinc-950 text-white py-4 px-4">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <a href="/" className="text-2xl sm:text-3xl font-black tracking-tighter hover:text-green-400 transition-colors">⚽ DOMINGÃO</a>
          <a href="/admin" className="text-sm font-bold hover:text-green-400 transition-colors"><Settings size={24} /></a>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-6">
        <a href="/" className="text-sm underline mb-4 inline-block text-zinc-600">← Voltar</a>

        <h1 className="text-2xl sm:text-3xl font-black tracking-tight uppercase flex items-center gap-2 mb-2">
          <Trophy size={28} className="text-yellow-500" /> COMO FUNCIONA A PONTUAÇÃO
        </h1>
        <p className="text-zinc-600 mb-6">
          O Pontos_Rating é a base do ranking. Cada acção em campo soma ou retira pontos. Quanto mais pontos, mais alto no ranking.
        </p>

        {loading ? (
          <div className="bg-white rounded-xl p-8 text-center text-zinc-500">A carregar...</div>
        ) : (
          <>
            <section className="bg-white rounded-2xl border-2 border-green-200 p-5 mb-4" data-testid="positivos">
              <h2 className="text-lg font-black uppercase text-green-700 mb-3 flex items-center gap-2">
                <Award size={20} /> Pontos Positivos
              </h2>
              <ul className="space-y-0">
                {positives.map(c => <Row key={c.key} item={c} />)}
              </ul>
            </section>

            <section className="bg-white rounded-2xl border-2 border-red-200 p-5 mb-4" data-testid="negativos">
              <h2 className="text-lg font-black uppercase text-red-700 mb-3">⚠️ Pontos Negativos</h2>
              <ul className="space-y-0">
                {negatives.length === 0 ? <p className="text-sm text-zinc-400 italic">Nenhum</p> : negatives.map(c => <Row key={c.key} item={c} />)}
              </ul>
            </section>

            {inactive.length > 0 && (
              <section className="bg-white rounded-2xl border-2 border-zinc-200 p-5 mb-4">
                <h2 className="text-lg font-black uppercase text-zinc-500 mb-3">Desactivados (peso = 0)</h2>
                <ul className="space-y-0">
                  {inactive.map(c => <Row key={c.key} item={c} />)}
                </ul>
              </section>
            )}

            <section className="bg-blue-50 border-2 border-blue-200 rounded-2xl p-5">
              <h3 className="font-bold text-blue-900 mb-2 flex items-center gap-2"><Info size={18} /> Notas importantes</h3>
              <ul className="text-sm text-blue-900 space-y-2 list-disc list-inside">
                <li><strong>Número de jogos</strong> NÃO conta para os Pontos_Rating — serve só de contador de presença.</li>
                <li><strong>JSG (Jogos Sem Sofrer Golo)</strong> só pontua para jogadores marcados como <em>Defesa</em> ou <em>Guarda-Redes</em>.</li>
                <li><strong>Defesas</strong> só pontuam para jogadores marcados como <em>Guarda-Redes</em>.</li>
                <li>O admin pode mudar os pesos a qualquer momento — o ranking recalcula automaticamente.</li>
                <li>A votação dos Prémios da Rodada (Puskás / Pintura / Melhor Defesa) atribui <strong>títulos</strong>, não pontos directos.</li>
              </ul>
            </section>
          </>
        )}
      </main>
    </div>
  );
};

export default PontuacaoPage;
